import axios from 'axios';

// In DRX-760, we increased the timeout to 60 seconds to allow for retrieving
// large order histories. This should probably be bumped back down to 20 seconds
// once the PatientOrders endpoint is reworked.
const axiosClient = axios.create({
    timeout: 120000
});
axiosClient.defaults.withCredentials = false;
const sessionStorage = (typeof window !== 'undefined' && window.sessionStorage) || undefined;
axiosClient.defaults.headers = {
    Authorization: `Bearer ${sessionStorage?.getItem('Authorization')}`,
    'Content-Type': 'application/json'
};

const cancelTokenSource = axios.CancelToken.source();

// Attach the CancelToken to every request and handle token expiration
const setLoggedOutInterceptor = () => {
    // Attach the cancel token to all requests
    axiosClient.interceptors.request.use(
        (config) => {
            config.cancelToken = cancelTokenSource.token;
            return config;
        },
        (error) => Promise.reject(error)
    );
};

//	header helpers
const setDefaultHeader = (name: string, value: any) => {
    axiosClient.defaults.headers[name] = value.toString();
};
const unsetDefaultHeader = (name: string) => {
    delete axiosClient.defaults.headers[name];
};
const getDefaultHeader = (name: string) => axiosClient.defaults.headers[name];

const isAxiosError = (error: unknown) => axios.isAxiosError(error);

export default axiosClient;

export { getDefaultHeader, setLoggedOutInterceptor, setDefaultHeader, unsetDefaultHeader, isAxiosError };
